
















































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { authorClient } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import {
  BatchAssignPermToRoleReq,
  BatchAssignDataPermReq,
  ChangeUserGroupInRoleReq
} from "@/pbjs/external/auth/auth_pb";
import { errorMsg, setCommon } from "@/utils/request";
import Edit from "./Edit.vue";
import { TreeNode, MarkMeta } from "@/pbjs/xcommon/module_pb";
import { Mark } from "@/pbjs/xcommon/enum_pb";
@Component({
  components: { Edit }
})
export default class UserManagement extends Vue {
  @Provide() private input: string = "";
  @Provide() private tableData: any = [];
  @Prop() data!: any;
  @Prop() defaultCheckKeys!: any;
  @Prop() roleid!: any;
  @Prop() isShowCommit: any;
  @Prop() type: any;
  @Prop() filiation: any;
  @Prop() activeName: any;
  @Provide() private token: string | null = "";
  @Provide() private newSelectedNodesArray: any = [];
  @Provide() private defaultSelectedNodesArray: any = [];
  @Provide() private newSelectedNodes: any = [];
  @Provide() private defaultSelectedNodes: any = [];
  @Provide() private newSelectedList: any = [];
  @Provide() private defaultSelectedList: any = [];
  @Provide() private isShowCheckBox: boolean = true;
  @Provide() private paternity: boolean = false;
  @Provide() private defaultProps: any = {
    children: "kidsList",
    label: "name",
    id: "id"
  };

  private created() {
    this.token = localStorage.getItem("token");
    if (this.filiation) {
      this.paternity = Boolean(this.filiation);
    }
  }
  private mounted(): void {
    const ref: any = this.$refs.tree;
    this.defaultSelectedNodes = ref.getCheckedNodes();
    this.defaultSelectedNodesArray = ref.getCheckedKeys();
    // let _data = this.data.filter((item: any) => {
    //     return item.mark == 0 && item.kidsList && (item.kidsList.length>0);
    // });
  }

  @Watch("activeName")
  onActiveChanged(val: string) {
    if (val === "per") {
      const ref: any = this.$refs.tree;
      this.newSelectedNodesArray = ref.getCheckedKeys();
      this.defaultSelectedNodesArray = this.defaultCheckKeys;
      if (
        !this.isArraySame(
          this.defaultSelectedNodesArray,
          this.newSelectedNodesArray
        )
      ) {
        this.$confirm(
          this.$tc(
            "The selected permission has not been saved. Do you want to save it?"
          ),
          "",
          {
            confirmButtonText: this.$tc("ticket.Sure"),
            cancelButtonText: this.$tc("authority.cancel")
          }
        )
          .then(() => {
            this.getCheckedNodes();
          })
          .catch(() => {
          });
      }
    }
    // else if (val === "data") {
    //     const ref:any = this.$refs.tree;
    //     this.newSelectedNodesArray = ref.getCheckedKeys();
    //     this.defaultSelectedNodesArray = this.defaultCheckKeys;
    //     if (!this.isArraySame(this.defaultSelectedNodesArray, this.newSelectedNodesArray)) {
    //         this.$confirm(this.$tc('The selected permission has not been saved. Do you want to save it?'), '', {
    //             confirmButtonText: this.$tc('ticket.Sure'),
    //             cancelButtonText: this.$tc('authority.cancel'),
    //         }).then(() => {
    //             this.getCheckedNodes();
    //         }).catch(() => {
    //         });
    //     }
    // }
  }

  @Watch("input")
  onInputChanged(val: string) {
    const ref: any = this.$refs.tree;
    ref.filter(val);
  }

  private isArraySame(oldArr: any, newArr: any): boolean {
    if (oldArr.length !== newArr.length) {
      return false;
    }
    newArr.sort((a: number, b: number) => a - b);
    oldArr.sort((a: number, b: number) => a - b);
    return newArr.toString() === oldArr.toString();
  }

  private filterNode(value: string, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }

  @Watch("defaultCheckKeys")
  onDefaultCheckKeysChanged(val: any) {
  }

  private setTreeNodeRequest(data: any) {
    let treeNodeLists: any = [];
    data.forEach((item: any) => {
      let treeNode: any = new TreeNode();
      treeNode.setId(item.id);
      treeNode.setPid(Number(item.pid));
      treeNode.setName(item.name);
      if (item.mark == 1) {
        treeNode.setMark(Mark.MARK_ON);
      } else {
        treeNode.setMark(Mark.MARK_OFF);
      }
      if (item.kidsList) {
        treeNode.setKidsList(this.setTreeNodeRequest(item.kidsList));
      }
      treeNodeLists.push(treeNode);
    });
    return treeNodeLists;
  }

  private getCheckedNodes() {
    const ref: any = this.$refs.tree;
    this.newSelectedNodesArray = ref.getCheckedKeys();
    this.newSelectedNodes = ref.getCheckedNodes();
    if (this.type === "roleGroup") {
      this.changeUserGroupInRole();
    } else if (this.type === "authorityGroup") {
      this.newSelectedNodesArray.push(...ref.getHalfCheckedKeys());
      this.batchAssignPermToRole();
    } else {
      this.batchAssignDataPermToUserGroup();
    }
  }

  // private assginPermissionAPI() {
  //     let add = this.findDiffArray(this.newSelectedNodesArray, this.defaultCheckKeys);
  //     let remove = this.findDiffArray(this.defaultCheckKeys, this.newSelectedNodesArray);
  //     let request:any = new BatchAssignPermissionForRoleReq();
  //     request.setTrackid("");
  //     request.setClientid("");
  //     request.setToken(this.token);
  //     request.setRoleidsList([this.roleid]);
  //     request.setAddedpermissionidsList(add);
  //     request.setDeletedpermissionidsList(remove);
  //     authorClient.batchAssignPermissionForRole(request, {}, (err: any, response:any) => {
  //         if(response) {
  //             let data:any = response.toObject();
  //         }
  //         if (err) {
  //             if (err.code == 16) {
  //                 this.$router.push("./login");
  //             }
  //         }
  //     });
  // }

  private findInitData(data: any, id: number) {
    data.find((item: any) => {
      if (item.mark == 1 && item.id == id) {
        return id;
      }
      if (item.kidsList) {
        this.findInitData(item.kidsList, id);
      }
    });
  }
  private batchAssignPermToRole() {
    // let add = this.findDiffArray(this.newSelectedNodesArray, this.defaultCheckKeys);
    // let remove = this.findDiffArray(this.defaultCheckKeys, this.newSelectedNodesArray);
    // let add = this.findDiffArray(this.newSelectedNodesArray, this.defaultSelectedNodes);
    // let remove = this.findDiffArray(this.defaultSelectedNodes, this.newSelectedNodesArray);
    let request: any = new BatchAssignPermToRoleReq();
    request.setCommonin(setCommon());
    request.setRoleid(this.roleid);
    request.setOrigintreeList(this.setTreeNodeRequest(this.data));
    request.setAllmarkedidsList(this.newSelectedNodesArray);
    authorClient.batchAssignPermToRole(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout) {
            if (data.commonout.code == 0) {
              this.$message({ type: "success", message: "submit successfully" });
              this.$emit("refreshData");
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          } else {
            if (data.code == 0) {
              this.$message({ type: "success", message: "submit successfully" });
              this.$emit("refreshData");
            } else {
              this.$message.error(data.errmsg);
            }
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
  // 2020-09-22  lin 分配权限，确定保存操作
  private batchAssignDataPermToUserGroup() {
    let request: any = new BatchAssignDataPermReq();
    request.setCommonin(setCommon());
    request.setUsergroupid(this.roleid);
    // if (this.activeName === "data") {
    let ticketData: number[] = [];
    let ticketAllData: any = [];
    for (let i = this.data.length - 1; i >= 0; i--) {
      if (this.data[i].ticket) {
        ticketData.push(this.data[i].id);
        ticketAllData.push(this.data[i]);
      } else {
        break;
      }
    }

    let selectedTicketData: number[] = this.findDiffArray(
      ticketData,
      this.findDiffArray(ticketData, this.newSelectedNodesArray)
    );
    let selectedTicketDataMeta: any = [];
    if (selectedTicketData && selectedTicketData.length > 0) {
      selectedTicketData.forEach((x: number) => {
        ticketAllData.forEach((y: any) => {
          if (x === y.id) {
            let meta: any = new MarkMeta();
            meta.setId(y.id);
            meta.setName(y.name);
            meta.setMark(Mark.MARK_ON);
            selectedTicketDataMeta.push(meta);
          }
        });
      });
    }
    let removeSelectedTicketData: number[] = this.findDiffArray(
      this.newSelectedNodesArray,
      ticketData
    );
    let removeSelectedTicketDefaultData: number[] = this.findDiffArray(
      this.defaultCheckKeys,
      ticketData
    );
    let add = this.findDiffArray(
      removeSelectedTicketData,
      removeSelectedTicketDefaultData
    );
    let remove = this.findDiffArray(
      removeSelectedTicketDefaultData,
      removeSelectedTicketData
    );
    request.setAddeddatapermidsList(add);
    request.setDeleteddatapermidsList(remove);
    request.setUnassignedticketpermsList(selectedTicketDataMeta);
    // request.addUnassignedticketperms(selectedTicketDataMeta);
    if (this.activeName) {
      enum DataPermKind {
        DATA_PERM_KIND_UNSPECIFIED = 0,
        DATA_PERM_KIND_PERSONAL,
        DATA_PERM_KIND_GROUP
      }
      let _DataPermKind: DataPermKind = DataPermKind.DATA_PERM_KIND_UNSPECIFIED;
      switch (this.activeName) {
        case "per":
          _DataPermKind = DataPermKind.DATA_PERM_KIND_UNSPECIFIED;
          break;
        case "data":
          _DataPermKind = DataPermKind.DATA_PERM_KIND_PERSONAL;
          break;
        case "groupdata":
          _DataPermKind = DataPermKind.DATA_PERM_KIND_GROUP;
          break;
      }
      request.setKind(_DataPermKind);
    }
    // } else if (this.activeName === "groupdata") {
    //     let add = this.findDiffArray(this.newSelectedNodesArray, this.defaultCheckKeys);
    //     let remove = this.findDiffArray(this.defaultCheckKeys, this.newSelectedNodesArray);
    //     request.setAddeddatapermidsList(add);
    //     request.setDeleteddatapermidsList(remove);
    // }
    authorClient.batchAssignDataPermToUserGroup(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout) {
            if (data.commonout.code == 0) {
              this.$message({ type: "success", message: "提交成功" });
              this.$emit("refreshData");
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          } else {
            if (data.code == 0) {
              this.$message({ type: "success", message: "submit successfully" });
              this.$emit("refreshData");
            } else {
              this.$message.error(data.errmsg);
            }
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private changeUserGroupInRole() {
    let add = this.findDiffArray(
      this.newSelectedNodesArray,
      this.defaultCheckKeys
    );
    let remove = this.findDiffArray(
      this.defaultCheckKeys,
      this.newSelectedNodesArray
    );
    let request: any = new ChangeUserGroupInRoleReq();
    request.setCommonin(setCommon());
    request.setRoleid(this.roleid);
    request.setAddedusergroupidsList(add);
    request.setDeletedusergroupidsList(remove);
    authorClient.changeUserGroupInRole(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.$message({ type: "success", message: "提交成功" });
            this.$emit("refreshData");
          } else if (data.code == 100100 || data.code == 100101) {
            this.$router.push("./login");
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
  private findSelectedNodes(data: any) {
    data.find((item: any) => {
      if (item.kidsList && item.kidsList.length > 0) {
        this.newSelectedList.push(item.id);
      }
      if (item.kidsList) {
        this.findSelectedNodes(item.kidsList);
      }
    });
  }
  // private testAddedNodes(id: number) {
  //     let _node: any = this.defaultSelectedNodes.filter((item: any) => {
  //         if(item.id === id && item.kidsList && item.kidsList.length>0){
  //             return item;
  //         }
  //     });
  //     if(_node) {
  //         return _node.kidsList.find((item: any) =>  item.mark == 0);
  //     }
  // }
  // private testDeletedNodes(id: number, data: any) {
  //     let _node: any = data.filter((item: any) => {
  //         if(item.id === id && item.kidsList && item.kidsList.length>0){
  //             return item;
  //         }
  //     });
  //     if(_node) {
  //         return _node.kidsList.some((item: any) =>  item.mark == 0);
  //     }
  // }
  // private findDefaultNodes(data: any) {
  //     data.forEach((item: any) => {
  //         if (item.mark == 0 && !(item.kidsList.length>0) && !(this.defaultSelectedList.includes(item.id))) {
  //             this.defaultSelectedList.push(item.id);
  //         }
  //         if(item.kidsList && item.kidsList.length>0) {
  //             this.findDefaultNodes(item.kidsList);
  //         }
  //     });
  // }
  private findDiffArray(a: any = [], b: any = []) {
    return a.filter((i: any) => {
      return b.indexOf(i) === -1;
    });
  }
}
